import React from 'react';
import styled from 'themed-components';

const WrapperElement = styled.div``;

export interface WrapperProps {
	children: JSX.Element[] | JSX.Element;
}
export const Wrapper = ({ children }: WrapperProps) => <WrapperElement>{children}</WrapperElement>;
